<script lang="ts">
  import ShareWithSocialButton from "../show_author_new/ShareWithSocialButton.svelte";
  import RelativePopup from "../show_author_new/RelativePopup.svelte";
  import CopyToClipboard from "@ui/CopyToClipboard.svelte";
  import { getSocialButtonContext } from "../show_author_new/socialContext";
  import { reportUserEvent, USER_EVENTS } from "@ui/reportEvents";
  import { fly } from "svelte/transition";

  export let isOpen: boolean = false;
  const context = getSocialButtonContext();

  $: if (isOpen) {
    reportUserEvent(USER_EVENTS.ShareButtonPopupOpen, {
      newsletterId: context.newsletterId
    });
  }

  function reportUserCopiedLink() {
    reportUserEvent(USER_EVENTS.ShareButtonPopupCopyLink, {
      newsletterId: context.newsletterId
    });
  }
</script>

<div class="popup-position">
  <RelativePopup position="bottom" bind:isOpen>
    <button
      class="flex items-center h-full px-1 py-5 pt-6 mx-2 font-bold rounded outline-none text-15 text-nxgray-600 focus:outline-none clickable">
      <span class="mr-2 -mt-1 pointer-events-none material-icons"> ios_share </span>
      Share
    </button>
    <span slot="icon" class="material-icons text-18 text-nxgray-300"> ios_share </span>
    <span slot="title" class="font-medium text-14"> Share newsletter </span>

    <div slot="content" class="flex flex-col items-start w-full" transition:fly|local={{ duration: 150, y: -10 }}>
      <h2 class="font-normal text-nxgray-300 text-13">Share on social media</h2>
      <div class="flex items-center justify-between w-full mt-2">
        <div class="overflow-hidden rounded">
          <ShareWithSocialButton socialMedia="facebook" colorOnHover={false} --height="30px" />
        </div>
        <div class="overflow-hidden rounded">
          <ShareWithSocialButton socialMedia="twitter" colorOnHover={false} --height="30px" />
        </div>
        <div class="overflow-hidden rounded">
          <ShareWithSocialButton socialMedia="pinterest" colorOnHover={false} --height="30px" />
        </div>
      </div>
      <h2 class="mt-3 font-normal text-nxgray-300 text-13">Share with link</h2>
      <div class="flex items-center justify-between w-full p-2 pr-2 mt-1 font-normal bg-gray-100 border rounded-md text-13">
        <div class="flex items-center">
          <span class="mr-2 material-icons text-18 text-nxgray-300"> link </span>
          <span>{context.shortUrl}</span>
        </div>
        <CopyToClipboard textToCopy={context.shortUrl} on:copied={reportUserCopiedLink}
          ><span class="flex items-center font-medium text-teal-700 hover:text-teal-600 clickable text-13">
            <span class="mr-1 material-icons text-15"> content_copy </span>
            Copy
          </span></CopyToClipboard>
      </div>
    </div>
  </RelativePopup>
</div>

<style>
  .popup-position {
    --right: -11.35rem;
    --top: 5rem;
    --popup-width: 360px;
    --chevron-left: 36%;
  }

  @media (min-width: 640px) {
    .popup-position {
      --right: -8rem;
      --chevron-left: 50%;
    }
  }
</style>
